import React from 'react';
import { BrowserRouter, Route } from "react-router-dom";
import './App.css';
import { Provider } from 'react-redux'
import { store } from './store/index'

import HomePage from './pages/home/homePage'
import NavBar from './pages/components/navbar/navbar'
import ResultCardsExample from './pages/components/cards/result-cards/example/result-cards-example'
import ColorCardsExample from './pages/components/cards/color-cards/color-card-example'
import TypeCardsExample from './pages/components/cards/type-cards/example/result-cards-example'
import PlantCardsExample from './pages/components/cards/select-plant-cards/example/result-cards-example'
import SizeIndicatorExample from './pages/components/cards/size-indicators/example'
import ResultSelectedCard from './pages/components/cards/spesific-result-cards/example/result-cards-example'
import AgacCaliExample from './pages/components/cards/agac-types/example/result-cards-example'
import YaprakTipiExample from './pages/components/cards/yaprak-tipi/example/result-cards-example'
import YaprakSekliExample from './pages/components/cards/yaprak-sekli/example/result-cards-example'
import ResultAgac from './pages/components/cards/agac-result/example/result-cards-example'
import SelectedAgac from './pages/components/cards/spesific-agac-result/example/result-cards-example'

import BizKimiz from './pages/bizkimiz/bizkimiz'
import BitkiOrtusuHakkinda from './pages/odtuflora/bitkiOrtusuHakkinda'
import Hebaryum from './pages/odtuflora/hebaryum'
import Hakkinda from './pages/nasilKullanilir/hakkinda'
import TurunuBul from './pages/nasilKullanilir/turunuBul'
import KardesProjeler from './pages/kardesProjeler/kardesProjeler'

import SearchPage from './pages/components/searchPage'

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <NavBar />
        <Route path="/" exact component={HomePage} />
        <Route path="/select-plant" component={PlantCardsExample} />
        <Route path="/color" component={ColorCardsExample} />
        <Route path="/type" component={TypeCardsExample} />
        <Route path="/size" component={SizeIndicatorExample} />
        <Route path="/result" component={ResultCardsExample} />
        <Route path="/selected-result" component={ResultSelectedCard} />
        <Route path="/agac" component={AgacCaliExample} />
        <Route path="/yaprakTipi" component={YaprakTipiExample} />
        <Route path="/yaprakSekli" component={YaprakSekliExample} />
        <Route path="/resultTree" component={ResultAgac} />
        <Route path="/selected-agac" component={SelectedAgac} />


        <Route path="/bizkimiz" component={BizKimiz} />
        <Route path="/bitki-ortusu-hakkinda" component={BitkiOrtusuHakkinda} />
        <Route path="/hebaryum" component={Hebaryum} />
        <Route path="/hakkinda" component={Hakkinda} />
        <Route path="/nasil-kullanilir" component={TurunuBul} />
        <Route path="/kardes-projeler" component={KardesProjeler} />

        <Route path="/search" component={SearchPage} />

      </BrowserRouter>
    </Provider>
  );
}

export default App;
